import axios from 'axios'
import { baseURL } from './constants'

export const AuthLogin = async (email, password) => {
    return axios({
        baseURL: baseURL,
        method: 'POST',
        url: '/auth/login',
        data: {
            email,
            password
        }
    })

}

async function asyncErrorHandler(promise) {
    try {
        const data = await promise
        return [data, null]
    }
    catch (error) {
        return [null, error]
    }
}



export const getCurrentUser = async () => {
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    const user = JSON.parse(localStorage.getItem('user'));

    if (!tokens || !user) {
        return null
    }

    const [isAuth, error] = await asyncErrorHandler(axios({
        baseURL: baseURL,
        method: 'GET',
        url: '/auth/check-auth',
        headers: {
            'Authorization': `Bearer ${tokens.access.token}`
        }
    }))

    if (!isAuth) {
        const response = await asyncErrorHandler(axios({
            baseURL: baseURL,
            method: 'POST',
            url: '/auth/refresh-tokens',
            data: {
                refreshToken: tokens.refresh.token
            }
        }))
        localStorage.setItem('tokens', JSON.stringify(response.data))
    }

    return user

};


export const AuthLogout = async (refreshToken) => {
    return axios({
        baseURL: baseURL,
        method: 'POST',
        url: '/auth/logout',
        data: {
            refreshToken,
        }
    })

}


export const AuthSignup = async (name, email, password, roles, courseName) => {
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    return axios({
        baseURL: baseURL,
        method: 'POST',
        url: '/auth/register',
        headers: {
            'Authorization': `Bearer ${tokens.access.token}`
        },
        data: {
            name, email, password, roles, courseName
        }
    })
}

export const findUserAndUpdate = async (email,roles,courseName) =>{
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    return axios({
        baseURL: baseURL,
        method: 'POST',
        url: '/users/update',
        headers: {
            'Authorization': `Bearer ${tokens.access.token}`
        },
        data: {
            email,
            roles,
            courseName
        }
    })
}